module.exports = __webpack_public_path__ + "static/img/sz.e19affce.png";